// FLOW FAQ (sections/flow-faq.liquid): live search over questions and answers.
// Without this script every question still shows; topic links are plain anchors.
class FlowFaq extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-flow-faq-search]');
    if (!this.input) return;
    this.items = [...this.querySelectorAll('[data-flow-faq-item]')];
    this.groups = [...this.querySelectorAll('[data-flow-faq-group]')];
    this.empty = this.querySelector('[data-flow-faq-empty]');
    this.input.addEventListener('input', () => this.filter(this.input.value));
  }

  filter(raw) {
    const query = raw.trim().toLowerCase();
    let shown = 0;
    this.items.forEach((item) => {
      const match = !query || item.textContent.toLowerCase().includes(query);
      item.hidden = !match;
      if (match) shown += 1;
    });
    this.groups.forEach((group) => {
      group.hidden = !group.querySelector('[data-flow-faq-item]:not([hidden])');
    });
    if (this.empty) this.empty.hidden = shown > 0;
  }
}

if (!customElements.get('flow-faq')) customElements.define('flow-faq', FlowFaq);

// Theme editor: open a question when its block is selected.
document.addEventListener('shopify:block:select', (event) => {
  if (event.target.matches?.('[data-flow-faq-item]')) event.target.open = true;
});
